"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Button = _interopRequireDefault(require("../Button"));
var __jsx = _react.default.createElement;
var EventSidebar = function EventSidebar(_ref) {
  var online = _ref.online,
    venue = _ref.venue,
    booth = _ref.booth,
    city = _ref.city,
    country = _ref.country,
    startdate = _ref.startdate,
    ctatext = _ref.ctatext,
    url = _ref.url,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      online: 'Virtual',
      booth: 'Booth'
    } : _ref$translations;
  if (online) {
    return __jsx("div", null, startdate && __jsx("p", null, __jsx("b", null, startdate)), __jsx("p", null, __jsx("b", {
      dangerouslySetInnerHTML: {
        __html: translations.online
      }
    })), url && __jsx(_Button.default, {
      text: ctatext,
      link: url
    }));
  }
  return __jsx("div", null, startdate && __jsx("p", null, __jsx("b", null, startdate)), venue && __jsx("p", null, __jsx("b", {
    dangerouslySetInnerHTML: {
      __html: venue
    }
  })), booth && __jsx("p", null, __jsx("b", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.booth, ": ").concat(booth)
    }
  })), city && country && __jsx("p", null, __jsx("b", {
    dangerouslySetInnerHTML: {
      __html: "".concat(city, ", ").concat(country, " ")
    }
  })), url && __jsx(_Button.default, {
    text: ctatext,
    link: url
  }));
};
var EventSidebarEditConfig = {
  emptyLabel: 'Configure EventSidebar Text',
  isEmpty: function isEmpty(props) {
    return !props || !props.city || props.city.trim().length < 1;
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/event-sidebar')(EventSidebar, EventSidebarEditConfig);
exports.default = _default;